<!-- 商品详情 -->
<template>
  <div class="comContent order">
    <div><el-button @click="goBack">返回</el-button></div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="商品 ID" prop="id" />
      <el-table-column label="商品名称" prop="name" />
      <el-table-column label="描述" prop="desc" />
    </el-table>
  </div>
</template>

<script>
export default {
  name:'GoodsDetail',
  components: {},
  data() {
    return {
      tableData: [{
        id: '12987123',
        name: '好滋好味鸡蛋仔',
        category: '江浙小吃、小吃零食',
        desc: '荷兰优质淡奶，奶香浓而不腻',
        address: '上海市普陀区真北路',
        shop: '王小虎夫妻店',
        shopId: '10333'
      }]
    };
  },
  computed: {},
  watch: {},
  methods: {
    goBack () {
      // console.log('go back');
      // this.$router.push("/reportMerchant/reportMerchant-reportList");

      // this.$router.go(-1)：后退+刷新；
      // this.$router.go(0)：刷新；
      // this.$router.go(1) ：前进
      this.$router.back(); //:后退
      // this.$router.back(0) 刷新；
      // this.$router.back(1)：前进
    },
  },
  created() {

  },
  mounted() {

  },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
}
</script>
<style lang='scss' scoped>
</style>
